import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as CuentaContableCrud from 'services/cuentaContable.service'

const CuentaContablePagoFormGroup = ({
  iMonedaValue,
  iError,
  iTouched,
  fIsSubmitting,
  handleChange,
  setFieldValue
}) => {
  const __zariContext = React.useContext(ZariContext)
  const [cuentasContables, setCuentasContables] = React.useState([])

  React.useEffect(() => {
    CuentaContableCrud.getCuentasContables_PorFiltros({
      prefijo: '10',
      moneda: iMonedaValue
    })
      .then(({ data }) => setCuentasContables(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [iMonedaValue, __zariContext])

  const onKeyDown = React.useCallback((e) => {
    KeyEventUtil.leaveOnEnterOrTab('select-medioDePago', e)
  }, [])

  const onChange = React.useCallback(
    (e) => {
      handleChange(e)
      setFieldValue('medioDePago', '')
    },
    [handleChange, setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='CAJA/BANCO' htmlFor='select-cuentaContablePago' md={4} size='sm' />
      <Col md={8}>
        <Field name='cuentaContablePago'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-cuentaContablePago'
              onKeyDown={onKeyDown}
              onChange={onChange}
            >
              {cuentasContables.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.text}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContablePagoFormGroup)
